import React, { useState, useEffect } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import AlertDialog from "../../ui/alerts/AlertDialog";

export default function CreateServiceType({ fetchData }) {
  // Form Modal State
  const [showCreate, setShowCreate] = useState(false);

  // Show and Hide Form Modal
  const handleClose = () => setShowCreate(false);
  const handleShow = () => setShowCreate(true);

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");

  const isEnabled = name.length > 0 && desc.length > 0;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // CREATE
  const createServiceType = async () => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios("https://ea1-dev.azurewebsites.net/api/serviceType", {
        method: "POST",
        data: {
          name: name,
          description: desc,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: JWT,
        },
      });
      setData(data);
      setIsLoading(false);

      // Hides Modal on submission
      setShowCreate(false);

      // Success Alert Popup
      setShowSuccess(true);

      // Clear form data on submit
      setName("");
      setDesc("");
    } catch (e) {
      setIsLoading(false);

      // Hides Modal on submission
      setShowCreate(false);

      // Error Alert Popup
      setShowError(true);
    }
  };

  // Table state update on submit
  useEffect(() => {
    fetchData(data);
  }, []);

  const createServiceModal = (
    <Modal show={showCreate} backdrop='static' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Service Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={createServiceType}>
          <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
            <Form.Label>Service Type Name</Form.Label>
            <Form.Control
              type='text'
              value={name}
              placeholder='Service Type Name'
              autoFocus
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='exampleForm.ControlTextarea1'>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as='textarea'
              rows={3}
              placeholder='Please describe what this service type is'
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='dark'
          onClick={createServiceType}
          disabled={!isEnabled}
        >
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
        handleClose();
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={"Service Type was successfully created."}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
        handleClose();
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error creating the Service Type."}
      />
    </Modal>
  );

  return (
    <>
      <Button variant='outline-dark' onClick={handleShow}>
        + Add
      </Button>
      {createServiceModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
